import { Box, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as React from "react";
import useWithdrawList from "../../hooks/useWithdrawList";
import Loader from "../Loader";
import AddWithdrawSetting from "../WithdrawSetting/AddWithdrawSetting";
import SingleWithdraw from "../WithdrawSetting/SingleWithdraw";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Withdrawsetting() {
  const [value, setValue] = React.useState(0);
  const { loading, error, withdrawList } = useWithdrawList();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Add New Withdraw" {...a11yProps(0)} />
          <Tab label="Withdraw Lists" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AddWithdrawSetting />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={5}>
          {withdrawList?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <SingleWithdraw withdraw={cs} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
    </Box>
  );
}
